require('./bootstrap');
import { createApp } from 'vue';
import ExampleComponent from "./components/ExampleComponent";
import YouryEmail from "./components/YouryEmail";
import YourySubmissionIndex from "./components/YourySubmissionIndex";
import YouryModal from "./components/YouryModal";
import YouryModalLink from "./components/YouryModalLink";
import YourySchoolSearch from "./components/YourySchoolSearch";
import YouryFormInput from "./components/YouryFormInput";
import YouryBarcode from "./components/YouryBarcode";
import VueFinalModal from 'vue-final-modal'
import MailCheck from 'mailcheck-vue'
import PrimeVue from 'primevue/config';
import ToastService from 'primevue/toastservice';
import Toast from 'primevue/toast';
const RootComponent = {
    /* options */
}

const app =createApp(RootComponent)
app.use(VueFinalModal())
app.use(PrimeVue);
app.use(ToastService);
app.config.compilerOptions.isCustomElement = tag => tag.startsWith('h-')
app.component('example', ExampleComponent)
app.component('MailCheck', MailCheck)
app.component('youry-email', YouryEmail)
app.component('youry-modal', YouryModal)
app.component('youry-modal-link', YouryModalLink)
app.component('youry-submission-index', YourySubmissionIndex)
app.component('youry-school-search', YourySchoolSearch)
app.component('youry-form-input', YouryFormInput)
app.component('youry-barcode', YouryBarcode)
    app.mount("#app")
